<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <img src="/static/img/404-page-error.png" class="center-block logo">
          <span>你迷路了嗎？</span>
          <div class="text-center col-sm-6 col-sm-offset-3">
            <router-link to="/">請按此返回首頁</router-link>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'NotFound'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// 404.vue?af4602a8